module.exports = __webpack_public_path__ + "static/img/mind.85f2d483.jpg";